import "./KeyboardKeyCap.css";

export default function KeyboardKeyCap({
  children,
  as: Component = "span",
  className = "",
  ...props
}) {
  return (
    <Component className={`keyboard-key-cap ${className}`.trim()} {...props}>
      {children}
    </Component>
  );
}
